import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "recent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_heading_with_filter = _resolveComponent("heading-with-filter")!
  const _component_product_list = _resolveComponent("product-list")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Loading... "))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "An error has occurred during products request."))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_heading_with_filter, {
              "sort-type": _ctx.sortType,
              "onUpdate:sort-type": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortType) = $event)),
              search: _ctx.searchString,
              "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchString) = $event)),
              title: _ctx.title
            }, null, 8, ["sort-type", "search", "title"]),
            _createVNode(_component_product_list, { products: _ctx.sortedAndSearchedProducts }, null, 8, ["products"]),
            _createVNode(_component_v_pagination, {
              "onUpdate:modelValue": _ctx.changePage,
              "model-value": _ctx.page,
              length: Math.ceil(_ctx.products?.total / 15),
              circle: ""
            }, null, 8, ["onUpdate:modelValue", "model-value", "length"])
          ]))
  ]))
}